import prioritizeStr from './prioritize-str';

export default function trueBeginnerStr(
  activity = {},
  key = '',
  isTrueBeginner = false
) {
  return prioritizeStr(
    activity[key],
    activity[`${key}Translation`],
    isTrueBeginner
  );
}
